import React, { useState, useContext, useRef, useEffect } from 'react';
import { BackgroundContext } from 'context/backgroundContext';
import MainContext from '../../MainContext';
import { ThemeContext } from 'context/themeContext';
import { HeightSpace, Wrapper } from 'components/wrapper';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Timer from './components/timer';
import { useTranslation } from 'react-i18next';

const InputsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 26.28vw;
`;

const InputWrapper = styled.div`
  position: Relative;
  width: 3.435vw;
  height: 3.539vw;
`;

const StyledInput = styled.input`
  width: 3.435vw;
  height: 3.539vw;
  border-width: 0;
  background-color: rgba(0, 0, 0, 0);
  text-align: center;
  box-sizing: border-box;
  color: ${(props) => props.theme.textPrimary};
  font-size: 1.82vw;
  outline: none;
`;

const StyledLine = styled.div`
  position: Relative;
  width: 3.435vw;
  height: 0.416vw;
  border-radius: 0.416vw;
  background-color: ${(props) =>
    props.selected ? props.theme.blueColorPrimary : props.theme.textPrimary};
`;

const Title = styled.div`
  position: Relative;
  color: ${(props) => props.theme.textPrimary};
  direction: ${(props) => (props.rtlDirection ? 'rtl' : 'ltr')};
  font-size: 1.145vw;
  font-weight: bold;
  margin-bottom: 1.3vw;
`;

const SecondTitle = styled.div`
  position: Relative;
  color: ${(props) => props.theme.textDisabled};
  font-size: 0.937vw;
  margin-bottom: 2.082vw;
  margin-top: 2.082vw;
  width: 22.28vw;
`;

const TimerWrapper = styled.div`
  width: 22.28vw;
  display: flex;
  flex-direction: row-reverse;
`;

const OTP = (props) => {
  const { email, confirmUserContext, changePasswordContext, setRedirectContext } =
    useContext(MainContext).login;
  const { setLeftWidth, setRotateAngle } = useContext(BackgroundContext);
  const { theme, rtlDirection } = useContext(ThemeContext);
  const [focusedInput, setFocusedInput] = useState('');
  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');
  const [input3, setInput3] = useState('');
  const [input4, setInput4] = useState('');
  const [input5, setInput5] = useState('');
  const [input6, setInput6] = useState('');
  const input_1 = useRef(null);
  const input_2 = useRef(null);
  const input_3 = useRef(null);
  const input_4 = useRef(null);
  const input_5 = useRef(null);
  const input_6 = useRef(null);
  let history = useHistory();
  const [timeLeft, setTimeLeft] = useState(300);
  const { t } = useTranslation();

  const { guest, guestId, modalStatus } = props;
  useEffect(() => {
    setRedirectContext('');
  }, []);
  useEffect(() => {
    if (!timeLeft) return;
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);
  if (email.length === 0) {
    history.push('/');
  }
  setRotateAngle(0);
  if (!props.changePassword && !modalStatus) {
    setLeftWidth(100);
  }
  const onInputChange = async (key, value) => {
    let input;
    if (value.length === 6) {
      setInput1(value.charAt(0));
      setInput2(value.charAt(1));
      setInput3(value.charAt(2));
      setInput4(value.charAt(3));
      setInput5(value.charAt(4));
      setInput6(value.charAt(5));
      input = value;
    }
    if (value.length === 1 || value.length === 2) {
      const newValue = value.charAt(value.length - 1);
      if (key === 'input_1') {
        input = newValue + input2 + input3 + input4 + input5 + input6;
        setInput1(newValue);
        input_2.current.focus();
      }
      if (key === 'input_2') {
        input = input1 + newValue + input3 + input4 + input5 + input6;
        setInput2(newValue);
        input_3.current.focus();
      }
      if (key === 'input_3') {
        input = input1 + input2 + newValue + input4 + input5 + input6;
        setInput3(newValue);
        input_4.current.focus();
      }
      if (key === 'input_4') {
        input = input1 + input2 + input3 + newValue + input5 + input6;
        setInput4(newValue);
        input_5.current.focus();
      }
      if (key === 'input_5') {
        input = input1 + input2 + input3 + input4 + newValue + input6;
        setInput5(newValue);
        input_6.current.focus();
      }
      if (key === 'input_6') {
        input = input1 + input2 + input3 + input4 + input5 + newValue;
        setInput6(newValue);
      }
    }
    if (input.length === 6) {
      {
        if (props.changePassword) {
          changePasswordFunc({
            password: props.password,
            otp_token: input,
          });
        } else {
          let data = {
            cellphone: email,
            otp_token: input,
          };
          if (guest) {
            data.guest = true;
            data.guest_id = guestId;
          }
          confirmUserContext(data);
        }
      }
    }
  };
  const changePasswordFunc = async (data) => {
    try {
      await changePasswordContext(data);
      props.setPasswordState(1);
    } catch {
      console.log('wrong otp');
    }
  };
  const onKeyDown = (key, e) => {
    if (e.key === 'Delete') {
      if (key === 'input_1') {
        setInput2('');
        input_2.current.focus();
      }
      if (key === 'input_2') {
        setInput3('');
        input_3.current.focus();
      }
      if (key === 'input_3') {
        setInput4('');
        input_4.current.focus();
      }
      if (key === 'input_4') {
        setInput5('');
        input_5.current.focus();
      }
      if (key === 'input_5') {
        setInput6('');
        input_6.current.focus();
      }
    }
    if (e.key === 'Backspace') {
      if (key === 'input_1') {
        if (input1.length !== 0) {
          setInput1('');
        }
      }
      if (key === 'input_2') {
        if (input2.length !== 0) {
          setInput2('');
        } else {
          input_1.current.focus();
        }
      }
      if (key === 'input_3') {
        if (input3.length !== 0) {
          setInput3('');
        } else {
          input_2.current.focus();
        }
      }
      if (key === 'input_4') {
        if (input4.length !== 0) {
          setInput4('');
        } else {
          input_3.current.focus();
        }
      }
      if (key === 'input_5') {
        if (input5.length !== 0) {
          setInput5('');
        } else {
          input_4.current.focus();
        }
      }
      if (key === 'input_6') {
        if (input6.length !== 0) {
          setInput6('');
        } else {
          input_5.current.focus();
        }
      }
    }
    if (e.key === 'ArrowLeft') {
      if (key === 'input_2') {
        input_1.current.focus();
      }
      if (key === 'input_3') {
        input_2.current.focus();
      }
      if (key === 'input_4') {
        input_3.current.focus();
      }
      if (key === 'input_5') {
        input_4.current.focus();
      }
      if (key === 'input_6') {
        input_5.current.focus();
      }
    }
    if (e.key === 'ArrowRight') {
      if (key === 'input_1') {
        input_2.current.focus();
      }
      if (key === 'input_2') {
        input_3.current.focus();
      }
      if (key === 'input_3') {
        input_4.current.focus();
      }
      if (key === 'input_4') {
        input_5.current.focus();
      }
      if (key === 'input_5') {
        input_6.current.focus();
      }
    }
  };
  const handleFocus = (key, e) => {
    setFocusedInput(key);
    e.target.select();
  };
  const handleBlur = () => {
    setFocusedInput('');
  };
  return (
    <>
      {!props.changePassword ? (
        <Wrapper modalStatus={modalStatus}>
          <Title rtlDirection={rtlDirection} theme={theme}>
            {t('otp.Enter the code sent to your email') + ' ' + email}
          </Title>
          <InputsWrapper>
            <InputWrapper>
              <StyledInput
                theme={theme}
                ref={input_1}
                value={input1}
                onChange={(e) => onInputChange('input_1', e.target.value)}
                onKeyDown={(e) => onKeyDown('input_1', e)}
                onFocus={(e) => handleFocus('input_1', e)}
                onBlur={handleBlur}
              />
              <StyledLine theme={theme} selected={focusedInput === 'input_1'} />
            </InputWrapper>
            <InputWrapper>
              <StyledInput
                theme={theme}
                ref={input_2}
                value={input2}
                onChange={(e) => onInputChange('input_2', e.target.value)}
                onKeyDown={(e) => onKeyDown('input_2', e)}
                onFocus={(e) => handleFocus('input_2', e)}
                onBlur={handleBlur}
              />
              <StyledLine theme={theme} selected={focusedInput === 'input_2'} />
            </InputWrapper>
            <InputWrapper>
              <StyledInput
                theme={theme}
                ref={input_3}
                value={input3}
                onChange={(e) => onInputChange('input_3', e.target.value)}
                onKeyDown={(e) => onKeyDown('input_3', e)}
                onFocus={(e) => handleFocus('input_3', e)}
                onBlur={handleBlur}
              />
              <StyledLine theme={theme} selected={focusedInput === 'input_3'} />
            </InputWrapper>
            <InputWrapper>
              <StyledInput
                theme={theme}
                ref={input_4}
                value={input4}
                onChange={(e) => onInputChange('input_4', e.target.value)}
                onKeyDown={(e) => onKeyDown('input_4', e)}
                onFocus={(e) => handleFocus('input_4', e)}
                onBlur={handleBlur}
              />
              <StyledLine theme={theme} selected={focusedInput === 'input_4'} />
            </InputWrapper>
            <InputWrapper>
              <StyledInput
                theme={theme}
                ref={input_5}
                value={input5}
                onChange={(e) => onInputChange('input_5', e.target.value)}
                onKeyDown={(e) => onKeyDown('input_5', e)}
                onFocus={(e) => handleFocus('input_5', e)}
                onBlur={handleBlur}
              />
              <StyledLine theme={theme} selected={focusedInput === 'input_5'} />
            </InputWrapper>
            <InputWrapper>
              <StyledInput
                theme={theme}
                ref={input_6}
                value={input6}
                onChange={(e) => onInputChange('input_6', e.target.value)}
                onKeyDown={(e) => onKeyDown('input_6', e)}
                onFocus={(e) => handleFocus('input_6', e)}
                onBlur={handleBlur}
              />
              <StyledLine theme={theme} selected={focusedInput === 'input_6'} />
            </InputWrapper>
          </InputsWrapper>
          <SecondTitle theme={theme}>
            {t(
              'otp.Enter the six-digit code sent to your email or log in to your account using the link provided.'
            )}
          </SecondTitle>
          <TimerWrapper>
            <Timer timeLeft={timeLeft} />
          </TimerWrapper>
        </Wrapper>
      ) : (
        <>
          <InputsWrapper>
            <InputWrapper>
              <StyledInput
                theme={theme}
                ref={input_1}
                value={input1}
                onChange={(e) => onInputChange('input_1', e.target.value)}
                onKeyDown={(e) => onKeyDown('input_1', e)}
                onFocus={(e) => handleFocus('input_1', e)}
                onBlur={handleBlur}
              />
              <StyledLine theme={theme} selected={focusedInput === 'input_1'} />
            </InputWrapper>
            <InputWrapper>
              <StyledInput
                theme={theme}
                ref={input_2}
                value={input2}
                onChange={(e) => onInputChange('input_2', e.target.value)}
                onKeyDown={(e) => onKeyDown('input_2', e)}
                onFocus={(e) => handleFocus('input_2', e)}
                onBlur={handleBlur}
              />
              <StyledLine theme={theme} selected={focusedInput === 'input_2'} />
            </InputWrapper>
            <InputWrapper>
              <StyledInput
                theme={theme}
                ref={input_3}
                value={input3}
                onChange={(e) => onInputChange('input_3', e.target.value)}
                onKeyDown={(e) => onKeyDown('input_3', e)}
                onFocus={(e) => handleFocus('input_3', e)}
                onBlur={handleBlur}
              />
              <StyledLine theme={theme} selected={focusedInput === 'input_3'} />
            </InputWrapper>
            <InputWrapper>
              <StyledInput
                theme={theme}
                ref={input_4}
                value={input4}
                onChange={(e) => onInputChange('input_4', e.target.value)}
                onKeyDown={(e) => onKeyDown('input_4', e)}
                onFocus={(e) => handleFocus('input_4', e)}
                onBlur={handleBlur}
              />
              <StyledLine theme={theme} selected={focusedInput === 'input_4'} />
            </InputWrapper>
            <InputWrapper>
              <StyledInput
                theme={theme}
                ref={input_5}
                value={input5}
                onChange={(e) => onInputChange('input_5', e.target.value)}
                onKeyDown={(e) => onKeyDown('input_5', e)}
                onFocus={(e) => handleFocus('input_5', e)}
                onBlur={handleBlur}
              />
              <StyledLine theme={theme} selected={focusedInput === 'input_5'} />
            </InputWrapper>
            <InputWrapper>
              <StyledInput
                theme={theme}
                ref={input_6}
                value={input6}
                onChange={(e) => onInputChange('input_6', e.target.value)}
                onKeyDown={(e) => onKeyDown('input_6', e)}
                onFocus={(e) => handleFocus('input_6', e)}
                onBlur={handleBlur}
              />
              <StyledLine theme={theme} selected={focusedInput === 'input_6'} />
            </InputWrapper>
          </InputsWrapper>
          <HeightSpace height="2vw" />
          <TimerWrapper>
            <Timer timeLeft={timeLeft} />
          </TimerWrapper>
        </>
      )}
    </>
  );
};

export default OTP;
